import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { SurveyService } from '../../../services';
import { SurveyDataInterface } from '../../../classes';

@Injectable()
export class SurveyDataResolve implements Resolve<Partial<SurveyDataInterface>> {

  constructor(
    protected survey:SurveyService,
  ) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Partial<SurveyDataInterface>> {
    const survey_id:string = route.paramMap.get('survey_id') || route.queryParamMap.get('survey_id'); 
    const checkin = this.survey.getLatest(survey_id).pipe(share())
    return checkin;
  }
}
